import { useEffect, useRef } from 'react'
import {
  evaluatePageNotice,
  recordPageNotice,
  type PageFacts,
  type PageName,
  type PageNotice,
  type PresentedNotices,
} from '../page-rules'
import type { PageState } from '../page-state'

/** Thin effect adapter. Rules decide eligibility; action handlers keep ownership of their native UI. */
export function usePageNotice<Page extends PageName>(input: {
  page: Page
  state: PageState
  visit: string
  facts: PageFacts[Page]
  actions: Record<PageNotice['id'], () => void>
}) {
  const presented = useRef<PresentedNotices | null>(null)
  useEffect(() => {
    const notice = evaluatePageNotice({ ...input, presented: presented.current })
    if (!notice) return
    // Commit the pure bookkeeping result before invoking UI, so repeated effects cannot open twice.
    presented.current = recordPageNotice(presented.current, input.visit, notice)
    input.actions[notice.id]()
  }, [input])
}
